export enum AnalyticsReportFeedbackRating {
  Positive = "positive",
  Negative = "negative",
}
